import { render } from "./CreateGallery.vue?vue&type=template&id=1a430529"
import script from "./CreateGallery.vue?vue&type=script&lang=js"
export * from "./CreateGallery.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__